<template>
    <div>
        <!--提示标题栏-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
                活动基础信息
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 35%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                活动基础信息
            </div>
        </div>
        <!--输入信息-->
        <div>
            <el-form :model="ecxForm" :rules="actrules" ref="ecxForm"
                     label-width="150px" class="demo-ruleForm" >
                <el-form-item label="活动名称" prop="actName">
                    <el-input v-model="ecxForm.actName"
                              placeholder="请输入活动名称"
                              maxlength="40"
                              style="width: 35%;" :disabled="isCheckStatus">
                    </el-input>
                </el-form-item>
                <el-form-item label="活动开始时间" prop="startTime">
                    <el-date-picker
                            v-model="ecxForm.startTime"
                            type="datetime"
                            placeholder="选择开始日期"
                            @change="getStartTime"
                            :disabled="isCheckStatus"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="活动结束时间" prop="endTime">
                    <el-date-picker
                            v-model="ecxForm.endTime"
                            type="datetime"
                            placeholder="选择结束日期"
                            @change="getEndTime"
                            default-time="23:59:59"
                            :disabled="isCheckStatus"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="活动说明" prop="remark">
                    <textarea v-model="ecxForm.remark"
                          placeholder="活动说明"
                          style="width: 35%;
                                height: 100px;"
                              maxlength="500"
                              @input="descInput()"
                          :disabled="isCheckStatus">
                    </textarea>
                    <span>{{remnant}}/500</span>
                </el-form-item>
                <!--下一步按钮-->
                <el-form-item style="margin-left: 24.5%">
                    <el-button type="primary" @click="submitForm('ecxForm')"
                               id="next_step" :disabled="isorgsubmit">下一步
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: "ActBase",
        props:["actID","status","act_status"],
        data() {
            return {
                isexpSecond: false,
                isorgsubmit: false,
                remnant: 500,
                actId:"",
                tenantId:'',
                isCheckStatus:false,
                ecxForm: {
                    actName: '',
                    startTime: '',
                    endTime: '',
                    remark: '',
                },
                actrules: {
                    actName: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                        {min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur'}
                    ],
                    startTime: [
                        {required: true, message: '请选择活动开始时间', trigger: 'change'}
                    ],
                    endTime: [
                        {required: true, message: '请选择活动结束时间', trigger: 'change'}
                    ],
                    remark:[
                        {min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'change'}
                    ]
                },
                start_Time:'',
                end_Time:'',
            }
        },
        created(){
            this.tenantId = this.getcookie("storeId");
            if (this.status=="1") {
                this.actId = this.actID;
                this.isCheckStatus = false
                console.log("编辑-活动基础信息："+this.actID)
                this.getActInfo(this.actID);
            }else if (this.status=="2") {
                this.actId = this.actID;
                this.isCheckStatus = true
                console.log("查看-活动基础信息："+this.actID)
                this.getActInfo(this.actID);
            }else{
                this.isCheckStatus = false
            }
        },
        methods: {
            descInput(){
                var txtVal = this.ecxForm.remark.length;
                this.remnant = 500 - txtVal;
            },
            getStartTime(vue) {
                var d = new Date(vue);
                this.start_Time = d.getTime();
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                this.ecxForm.startTime = moment(d).format(formatString);
            },
            getEndTime(vue) {
                var d = new Date(vue);
                this.end_Time = d.getTime();
                if (this.end_Time - this.start_Time > 0) {
                    // var formatString = formatString || 'YYYY-MM-DD ';
                    var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                    this.ecxForm.endTime = moment(d).format(formatString)/*+"23:59:59"*/;
                    console.log("结束时间："+this.ecxForm.endTime+"---"+vue)
                }else{
                    this.ecxForm.endTime = "";
                    this.$message({showClose: true,message: '结束时间早于开始时间',type: 'error'});
                    return false;
                }
            },
            submitForm(formName){
                if (this.ecxForm.actName + "" === "") {
                    this.$message({showClose: true,message: '请输入活动名称',type: 'error'});
                    return false;
                }
                if(this.ecxForm.actName.length>40){
                    this.$message({showClose: true,message: '长度在 1 到 40 个字符',type: 'error'});
                    return false;
                }
                if (this.ecxForm.startTime + "" === "") {
                    this.$message({showClose: true,message: '请选择开始时间',type: 'error'});
                    return false;
                }
                if (this.ecxForm.endTime + "" === "") {
                    this.$message({showClose: true,message: '请选择结束时间',type: 'error'});
                    return false;
                }if(this.ecxForm.remark.length>500){
                    this.$message({showClose: true,message: '长度在 1 到 500 个字符',type: 'error'});
                    return false;
                }
                if (this.status=="1") {
                    console.log("修改活动")
                    this.updateActinfo();
                }else if (this.status=="0") {
                    console.log("创建活动"+this.actID)
                    this.checkActName(this.ecxForm.actName)
                }else if (this.status=="2"){
                    console.log("查看活动")
                    this.sendMsgToParent(this.actId);
                }
                // this.sendMsgToParent("act001");
            },
            /*卡片跳转--id:活动ID*/
            sendMsgToParent:function (id) {
                console.log("创建："+id)
                this.$emit("listenToChildEvent","2",id)
            },
            /*修改时获取的时间做格式转换 --2019-04-30T03:50:10.000+0000*/
            formatter(date) {
                var d = new Date(date);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            /*验证活动名称*/
                checkActName(name){
                //数据请求
                this.loading = true
                //异步请求
                this.$http.get(this.actManagerHost+this.checkActNameURL + "?actName=" + name+"&tenantId="+this.getcookie("storeId")+"")
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code === "200") {
                                if (this.actID == " ") {
                                    this.postActInfo()
                                }else{
                                    this.updateActinfo();
                                }
                            }else if (response.body.Code === "201") {
                                /*名称已存在*/
                                this.updateActinfo();
                            }else{
                                this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                            }
                        }
                    }, function (response) {
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*提交活动信息*/
            postActInfo() {
                //数据请求
                this.loading = true
                var params = {actName:this.ecxForm.actName,startDate:this.ecxForm.startTime,
                    endDate:this.ecxForm.endTime,
                    actDesc:this.ecxForm.remark,tenantId:this.tenantId};
                //异步请求
                this.$http.post(this.actManagerHost+this.createActURL,params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                this.actId = response.body.Data.actId;
                                this.sendMsgToParent(this.actId);
                                this.$message({showClose: true, message: '提交成功', type: 'success'});
                            } else {
                                this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                            }
                        }
                    },function(response){
                        this.$message({ showClose: true,  message: '网络异常', type: 'error' });
                    })
            },
            /*根据活动ID获取活动信息*/
            getActInfo(id){
                //数据请求
                this.loading = true
                //异步请求
                this.$http.get(this.actManagerHost+this.getActInfoURL + "?actId=" + id )
                    .then(response => {
                        console.log(response.body.Data)
                        if (response.status === 200) {
                            console.log("//////////////////////////")
                            if (response.body.Code === "200") {
                                /*成功*/
                                this.ecxForm.actName = response.body.Data.actInfo.act_name;
                                this.ecxForm.startTime = response.body.Data.actInfo.act_start_date;
                                this.ecxForm.endTime = response.body.Data.actInfo.act_end_date;
                                this.ecxForm.remark = response.body.Data.actInfo.act_desc;
                                this.actId = response.body.Data.actInfo.actId;
                                this.loading = false;
                            }else if (response.body.Code === "500") {
                                /*异常*/
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'

                                });
                            }
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            /*修改活动*/
            updateActinfo(){
                //数据请求
                this.loading = true
                // console.log("参数："+this.ecxForm.actName+"\n"+this.formatter(this.ecxForm.startTime)+"\n"
                //     +this.formatter(this.ecxForm.endTime)+"\n"+this.ecxForm.remark+"\n"
                //     +this.actId)
                var params = {actName:this.ecxForm.actName,startDate:this.formatter(this.ecxForm.startTime),
                    endDate:this.formatter(this.ecxForm.endTime),
                    actDesc:this.ecxForm.remark,actId:this.actId};
                //异步请求
                this.$http.post(this.actManagerHost+this.postUpdateActInfoURL,params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                this.$message({showClose: true, message: '修改成功', type: 'success'});
                                this.sendMsgToParent(this.actId);
                            }else {
                                this.$message({  showClose: true,  message: response.body.Meta, type: 'error' });
                            }
                        }
                    },function(response){
                        console.log("fail")
                        this.$message({ showClose: true,  message: '网络异常', type: 'error' });
                    })

            },
        },
    }

</script>

<style scoped>
    .demo-ruleForm {
        margin: 20px auto 0 auto;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// ActBase.vue?b27a162c